import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'brt-overlay-window-header',
  templateUrl: './overlay-window-header.component.html',
  styleUrls: ['./overlay-window-header.component.scss']
})
export class OverlayWindowHeaderComponent {
  @ViewChild('customContent') customContent!: ElementRef<void>;
  @Output("onClosed") onClosed = new EventEmitter<boolean>();
  @Input('title') set setTitle(val: string) {
    this.title = val;

    if(val.length > 45) {
      this.title = `${val.slice(0, 42)}...`
    } else {
      this.title = val;
    }    

    this.isTitleEmpty = this.title.length === 0;
  };

  @Input('bottomLine') bottomLine = true;
  @Input('noBackdropFilter') noBackdropFilter = false;

  title = "";

  isTitleEmpty = this.title.length === 0;
}
